import React from 'react';
import Header from '../homepage/components/Header';
import Footer from '../homepage/components/Footer';
import Seo from '../../components/Seo';

const AboutPage = () => {
  const filmProjects = [
    "28 YEARS LATER",
    "PRINCE OF PERSIA",
    "ROBIN HOOD",
    "NANIA VOYAGES OF THE DAWN TREADER",
    "FAST AND FURIOUS 5",
    "SHERLOCK HOLMS 2",
    "JACK THE GIANT KILLER",
    "DARK SHADOWS",
    "THE HOBBIT PART 1",
    "THE HOBBIT PART 2",
    "THE HUNGER GAMES 2",
    "IRON MAN 3",
    "AVENGERS",
    "MAN OF STEEL",
    "PASSENGERS",
    "KING ARTHUR",
    "JUNGLE BOOK",
    "TERMINATOR 5 GENISYS",
    "GUARDIANS OF THE GALAXY",
    "HUNGER GAMES MOCKINGJAY PART 2",
    "SAN ANDREAS QUAKE",
    "EXODUS",
    "GUARDIANS OF THE GALAXY 2",
    "PADDINGTON 2",
    "WOMAN KING",
    "MEG 2",
    "SWIM",
  ];

  const filmHalf = Math.ceil(filmProjects.length / 2);
  const filmProjectsLeft = filmProjects.slice(0, filmHalf);
  const filmProjectsRight = filmProjects.slice(filmHalf);

  const tvProjects = [
    "THE CROWN",
    "THE WITCHER",
    "BLACK MIRROR CALLISTER",
    "AWAY MARS",
    "MARS 2",
    "OMENS 2",
  ];

  return (
    <>
      <Seo
        title="About - Skyline VFX"
        description="Learn about Lee Munday, Digital Matte Painter and Concept Artist with experience in film and television VFX."
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-32 pb-20 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Title */}
            <div className="text-center mb-10">
              <h1 className="text-4xl lg:text-5xl font-bold mb-4">About</h1>
              <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto">
                I'm a Digital Matte Painter and Concept Artist specializing in creating photorealistic environments for film and television productions.
              </p>
            </div>
            
            {/* Bio Section */}
            <div className="prose prose-invert prose-lg max-w-none">
              <div className="mt-12 text-center">
                <h2 className="text-2xl font-semibold text-white mb-4">Experience</h2>
                <p className="text-gray-400 leading-relaxed max-w-3xl mx-auto">
                  With 25+ years experience in the VFX industry, I've contributed to numerous high-profile productions, creating digital environments that seamlessly blend with live-action footage.
                </p>
              </div>

              <div className="mt-12 grid md:grid-cols-2 gap-12 items-start">
                <div className="text-center">
                  <h2 className="text-2xl font-semibold text-white mb-4">Skills</h2>
                  <ul className="inline-block text-center space-y-2 text-gray-400">
                    <li>Digital Matte Painting</li>
                    <li>Concept Art &amp; Design</li>
                    <li>Environment Design</li>
                    <li>Set Extension</li>
                    <li>2.5D Projection</li>
                  </ul>
                </div>

                <div className="text-center">
                  <h2 className="text-2xl font-semibold text-white mb-4">Software</h2>
                  <div className="flex flex-wrap gap-3 justify-center">
                    {['Photoshop', 'Nuke', 'Maya', 'After Effects', 'Blender', 'Unreal Engine'].map((tool) => (
                      <span key={tool} className="px-4 py-2 bg-white/5 rounded-none text-gray-300 text-sm">
                        {tool}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <h2 className="text-2xl font-semibold text-white mb-4">Film Projects</h2>
                <div className="flex justify-center">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-44 md:gap-x-56 gap-y-2 w-fit text-gray-400">
                    <ul className="space-y-2 text-center">
                      {filmProjectsLeft.map((p) => (
                        <li key={p}>{p}</li>
                      ))}
                    </ul>
                    <ul className="space-y-2 text-center">
                      {filmProjectsRight.map((p) => (
                        <li key={p}>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <h2 className="text-2xl font-semibold text-white mb-4">TV Projects</h2>
                <ul className="inline-block text-center space-y-2 text-gray-400">
                  {tvProjects.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
